export const buildFilters = (props) => {
    const filters = props.headers?.data?.map((h, i) => {
        if (h?.canBeFiltered) {
            const filterValues = [];
            props.data?.forEach((e) => {
                const value = e.cells[i]?.data.value;
                const display = e.cells[i]?.data.display;
                if (!e.isHiddenWithLoadMore && !filterValues?.find((f) => f.value === value)) {
                    filterValues.push({ value: value, display: display });
                }
            });
            let options = [
                {
                    label: props.allFiltersLabel,
                    value: undefined
                }
            ];
            filterValues?.forEach((v) => {
                if (v.display?.props?.message) {
                    v.display.props.message = '';
                }
                options.push({
                    label: v.display ?? v.value,
                    value: v.value
                });
            });
            options = options.sort((a, b) => {
                if (a.value === undefined) {
                    return -1;
                }
                else if (b.value === undefined) {
                    return 1;
                }
                else if (a.value === 0) {
                    return -1;
                }
                else if (b.value === 0) {
                    return 1;
                }
                else {
                    return a.value > b.value ? 1 : -1;
                }
            });
            return {
                label: h?.label,
                placeholder: options[0].label,
                options: options,
                value: null,
                classNames: '!w-fit min-w-8'
            };
        }
    });
    return filters;
    // Il est essentiel de conserver la même longueur de tableau pour la liste des filtres que pour celle des colonnes,
    // car les filtres sont associés aux colonnes par leur index. Si la longueur du tableau est modifiée en filtrant les éléments `undefined`,
    // les filtres pourraient ne plus correspondre aux bonnes colonnes, rendant ainsi la correspondance entre filtres et colonnes incorrecte.
    // .filter((e) => e !== undefined);
};
